import { Business } from './business';
import { Locale } from './locale';
import { PaymentAccount } from './payment_account';
// import { PaymentProvider } from './payment_provider';
import { User } from './user';

export interface Transaction {
  id?: string;
  amount?: string;
  code?: string;
  label?: string;
  type?: TransactionType;
  status?: TransactionStatus;
  customer_number?: string | null;
  customer_nickname?: string;
  sender_status?: TransactionStatus;
  receiver_status?: TransactionStatus;
  sender_account?: PaymentAccount | string | null; // Data sent back for sender and receiver would be abstracted accordingly to protect sender and receiver privacy
  receiver_account?: PaymentAccount | string | null;
  sender?: User | string | null;
  receiver?: User | string | null;
  business_receiver?: Business | string | null;
  business_sender?: Business | string | null;
  was_offline?: boolean;
  latitude?: string;
  longitude?: string;
  country?: Locale | string;
  date_created?: string;
  date_updated?: string;
}

export interface PaymentReason {
  id: string;
  name?: string;
  code?: string;
  icon?: string;
  translations?: PaymentReason[];
}

export enum TransactionType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
  TRANSFER = 'TRANSFER',
  PAYMENT = 'PAYMENT',
  REFUND = 'REFUND',
  CHARGE = 'CHARGE',
  FEES = 'FEES',
  BUY_AIRTIME = 'BUY_AIRTIME',
  BUY_DATA = 'BUY_DATA',
  SEND_MONEY = 'SEND_MONEY',
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  OTHER = 'OTHER',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  // SUCCESS = 'SUCCESS',
  ALL = 'ALL',
  CONFIRMED = 'CONFIRMED',
  INITIATED = 'INITIATED',
  // FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
